import { HttpErrorResponse } from '@angular/common/http';
import { QueryLoadingState, QueryOptions } from '@globalconnect/query';

export interface SharepointExportItem {
  reportType: ReportTypes;
  totalAmount: number;
  readyToExport: number;
  status: SharepointExportItemStatus;
  inProgress: number;
  exported: number;
  failed: number;
  exportButton: {
    status: ExportButtonStatus;
    amount: number;
  };
}

export interface ExportReportsRequestBody {
  locale: string;
  reportTypes: ReportTypes[];
}

export type SharepointExportResponse = SharepointExportItem[];

export type SharepointExportResponseQueryLoadingState = QueryLoadingState<
  SharepointExportResponse,
  HttpErrorResponse,
  SharepointExportResponse
>;

export type SharepointExportResponseQueryOptions = QueryOptions<
  SharepointExportResponse,
  HttpErrorResponse,
  never,
  SharepointExportResponse
>;

//THIS IS DEF WRONG SOMEWHERE, DOUBLE CHECK IT
export enum ReportTypes {
  CABINET = 'CABINET',
  WORK_VARIATION = 'WORK_VARIATION',
  HUB = 'HUB',
  HC = 'HC',
  HP = 'HP',
  LAND_AGREEMENT = 'LAND_AGREEMENT',
  LAND_SURVEY = 'LAND_SURVEY',
  SITE = 'SITE',
  SPAN = 'SPAN',
  MANHOLE = 'MANHOLE',
  MDU_BUILDING = 'MDU_BUILDING',
  MDU_DELIVERY_POINT = 'MDU_DELIVERY_POINT',
}

export enum SharepointExportItemStatus {
  NONE = 'NONE',
  READY = 'READY',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum ExportButtonStatus {
  NOT_READY = 'NOT_READY',
  SOME_READY = 'SOME_READY',
  ALL_READY = 'ALL_READY',
  ALL_COMPLETED = 'ALL_COMPLETED',
  EXPORTING = 'EXPORTING',
}
